import React from "react";
import { Link } from "react-router-dom";
import { SITE, NAV } from "../data/mock";

export default function Footer() {
  return (
    <>
      {/* Blue CTA banner */}
      <section className="bg-[#29abe2] text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 flex flex-col md:flex-row items-center justify-between gap-6">
          <h3 className="text-2xl md:text-3xl font-semibold uppercase tracking-wide text-center md:text-left">
            Ready to get started? Reach out to our team
          </h3>
          <Link
            to="/contact-us"
            className="inline-block bg-[#1c3d52] hover:bg-[#142d3e] text-white font-semibold tracking-widest text-sm px-10 py-4 rounded transition-colors whitespace-nowrap"
          >
            CONTACT US
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#3a4b5c] text-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <img src={SITE.logo} alt="TapTrack" className="h-14 w-auto mb-5" />
            <p className="text-[14px] leading-relaxed text-slate-300 max-w-xs">{SITE.tagline}</p>
          </div>

          <FooterCol title="Services" items={NAV.services} />
          <FooterCol title="Resources" items={NAV.resources} />
          <FooterCol title="Company" items={NAV.company} />
        </div>
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 text-[13px] text-slate-300">
            © Copyright {new Date().getFullYear()} | TapTrack
          </div>
        </div>
      </footer>
    </>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <h4 className="text-white font-semibold mb-5 text-[15px]">{title}</h4>
      <ul className="space-y-3">
        {items.map((it) => (
          <li key={it.label}>
            <Link to={it.href} className="text-[14px] text-slate-300 hover:text-[#29abe2] transition-colors">
              {it.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
